var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"Logout pointer",on:{"click":_vm.LogoutApp}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'sign-out-alt']}}),_vm._v(" Logout ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }